import { useContext, useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import Format from '../../../../Services/Format';
import { FaEdit } from 'react-icons/fa';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DateUtils from '../../../../Services/DateUtils';
import Globals from '../../../../Globals.json';
import {
  HiOutlineDocumentDuplicate,
  HiOutlineDotsVertical,
} from 'react-icons/hi';
import { InputDefault } from '../../../data/inputDefault';
import ReactSelect from '../../../data/reactSelect';
import LayoutFilter from '../../../data/LayoutFilter';
import LayoutTable from '../../../data/LayoutTable';
import tableStyleDefault from '../../../../Services/tableStyleDefault';
import { ProdutoContext } from '../../../../context/product';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import { paginationOptions } from '../../../data/PagineteInfo';
import ActiveInactiv from '../../../data/activeInactive';
import CustomLoader from '../../../data/customLoader';
import { Button, Dropdown } from 'react-bootstrap';
import * as S from './styled';
import { useDispatch } from 'react-redux';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { useFetchById } from '../../../../apiQuery/useFetchById';
import Loading from '../../../Loading/Loading';
import { notify, notifyError } from '../../../notify/notify-component';
import api from '../../../../Services/api';
import Spinner from '../../../spinner/Spinner';
import ImportResultModal, { ImportResult } from './ImportResultModal';

export default function ListaProdutos(props: any) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const { setMinSale, setCoast, setProductsComplement } =
    useContext(ProdutoContext);

  const [typedate, setTypeDate] = useState<number>(0);
  const [category, setCategory] = useState<any>('');
  const [idPdv, setIdPdv] = useState<string>('');
  const [startDate, setStartDate] = useState<string>(
    Format.firstDate('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState<string>(
    Format.date(DateUtils.endOfMonth(), 'YYYY-MM-DD')
  );

  const [type, setType] = useState<any>();
  const [status, setStatus] = useState<any>('');
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [uuidProduct, setUuidProduct] = useState<{
    uuid: string;
    isEdite: boolean;
  }>();
  const [page, setPage] = useState(1);
  const [sortCode, setSortCode] = useState(false);
  const [sortPrice, setSortPrice] = useState(false);
  const [sortCost, setSortCost] = useState(false);
  const [sortSaleName, setSortSaleName] = useState(false);
  const [sort, setSort] = useState('');

  const [name, setName] = useState<string>();
  const [isExporting, setIsExporting] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [importResult, setImportResult] = useState<ImportResult | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleExportXls = async () => {
    setIsExporting(true);
    try {
      const response = await api.get(
        `api/v1/produtos/exportar-xls?store_id=${storeMe?.storeActive?.id}`,
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'produtos_exportados.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      notifyError('Erro ao exportar produtos. Tente novamente.');
    } finally {
      setIsExporting(false);
    }
  };

  const handleImportXls = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';

    const formData = new FormData();
    formData.append('file', file);
    formData.append('store_id', String(storeMe?.storeActive?.id));

    setIsImporting(true);
    try {
      const response = await api.post('api/v1/produtos/importar-xls', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const { updated = 0, inserted = 0, errors = [] } = response.data ?? {};
      if (errors.length > 0) {
        setImportResult({ inserted, updated, errors });
      } else {
        notify(`${inserted} produtos inseridos, ${updated} produtos atualizados.`);
      }
      setPage(1);
      refetch();
    } catch (err: any) {
      notifyError(err?.message ?? 'Erro ao importar produtos. Verifique o ficheiro e tente novamente.');
    } finally {
      setIsImporting(false);
    }
  };

  const { data, isLoading, isError, refetch } = useQueryFetchPages(
    ['products'],
    `${Globals.api.products}/minified`,
    {
      page: page,
      queryParams: {
        append: 'stock_qty',
        include: 'purpose,category,type,sale_measure_unit',
        store_id: storeMe?.storeActive?.id,

        ...(typedate === 1 && { 'filter[created_from]': startDate }),
        ...(typedate === 1 && { 'filter[created_until]': endDate }),

        ...(sort && { sort }),
        ...(idPdv && { 'filter[id_pdv]': idPdv }),
        ...(type && { 'filter[product_type_id]': type }),
        ...(category && { 'filter[id_pdv_category]': category }),
        ...(status !== '' && { 'filter[is_active]': status }),

        ...(name &&
          name.trim().length > 2 && {
            'filter[product_name]': name.trim(),
          }),
        id_number: 1,
      },
    }
  );

  const {
    data: productByUuid,
    isLoading: isLoadingProductById,
    isError: isErrorProductById,
  } = useFetchById<any>(
    'products',
    `${Globals.api.products}`,
    uuidProduct?.uuid,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        id_number: 2,
      },
    }
  );

  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['category'],
    `${Globals.api.categoriesCompleted}/minified`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );

  const {
    data: productTypes,
    isLoading: isLoadingProductTypes,
    isError: isErrorProductTypes,
  } = useQueryFetchPages<any>(['productTypes'], `${Globals.api.productTypes}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });

  const listdate = [
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Data Cadastro' },
  ];

  const listStatus = [
    { value: '', label: 'Todos' },
    { value: true, label: 'Ativos' },
    { value: false, label: 'Inativos' },
  ];

  const handleNew = () => {
    setMinSale('0.01');
    setCoast('0.01');
    props.onNewProduct();
  };

  const isLater = (start: string, end: string) => {
    return start > end;
  };

  const handleDateStart = async (date: string) => {
    if (!date) return;
    if (date.length !== 10) {
      return;
    }
    setStartDate(date);
    const dateValid = isLater(date, endDate);
    if (dateValid) {
      return;
    }
  };

  



  const handleDateEnd = async (date: string) => {
    if (!date) return;
    if (date.length !== 10) {
      return;
    }
    setEndDate(date);
    const dateValid = isLater(startDate, date);
    if (dateValid) {
      return;
    }
  };

  const handleSortCode = () => {
    const newSort = sortCode ? 'id_pdv' : '-id_pdv';
    setSortCode(!sortCode);
    setSort(newSort);
  };

  const handleSortPrice = () => {
    const newSort = sortPrice ? 'sale_price' : '-sale_price';
    setSortPrice(!sortPrice);
    setSort(newSort);
  };

  const handleSortCost = () => {
    const newSort = sortCost ? 'cost_price' : '-cost_price';
    setSortCost(!sortCost);
    setSort(newSort);
  };

  const handleSortSaleName = () => {
    const newSort = sortSaleName ? 'sale_name' : '-sale_name';
    setSortSaleName(!sortSaleName);
    setSort(newSort);
  };

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPage(page);
  };

  const columns: any = [
    {
      name: 'Código',
      sortable: true,
      sortFunction: handleSortCode,
      width: '88px',
      center: true,
      selector: (row: any) => row.id_pdv,
    },
    {
      name: 'Produto',
      minWidth: '190px',
      sortable: true,
      sortFunction: handleSortSaleName,
      selector: (row: any) => {
        return (
          <div
            title="Editar"
            style={{
              cursor: 'pointer',
            }}
            onClick={() => setUuidProduct({ uuid: row.uuid, isEdite: true })}
          >
            {row.sale_name?.toUpperCase()}
          </div>
        );
      },
    },

    {
      name: 'Tipo',
      center: true,
      selector: (row: any) =>
        row?.relationships?.type?.product_type_description,
    },
    {
      name: 'Operação',
      minWidth: '90px',
      center: true,
      selector: (row: any) =>
        row.relationships?.purpose?.product_purpose_description,
    },

    {
      name: 'Custo',
      selector: (row: any) =>
        row.cost_price?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
      width: '85px',
      center: true,
      sortable: true,
      sortFunction: handleSortCost,
    },
    {
      name: 'Venda',
      selector: (row: any) =>
        row.sale_price?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
      width: '85px',
      center: true,
      sortable: true,
      sortFunction: handleSortPrice,
    },
    {
      name: 'Promocional',
      selector: (row: any) =>
        row.promotional_price?.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
      width: '100px',
      center: true,
    },
    {
      name: 'Categoria',
      center: true,
      selector: (row: any) => row?.relationships?.category?.name ?? '',
    },
    {
      name: 'Qtd.',
      selector: (row: any) => row?.stock_qty?.toFixed(2)?.replace('.', ','),
      width: '80px',
      center: true,
    },
    {
      name: 'Unidade',
      width: '94px',
      center: true,
      selector: (row: any) =>
        row.relationships?.sale_measure_unit?.name.toLowerCase() ?? '',
    },
    {
      name: 'Status',
      width: '84px',
      center: true,
      selector: (row: any) =>
        row.is_active ? (
          <ActiveInactiv status={row.is_active} text="Ativo" />
        ) : (
          <ActiveInactiv status={row.is_active} text="Inativo" />
        ),
    },
    {
      name: 'Ação',
      width: '60px',
      center: true,
      cell: (row: any) => (
        <Dropdown>
          <Dropdown.Toggle variant="white" id="dropdown-basic" size="sm">
            <HiOutlineDotsVertical />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => setUuidProduct({ uuid: row.uuid, isEdite: false })}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '1rem',
                  alignItems: 'center',
                  fontSize: '12px',
                }}
              >
                <HiOutlineDocumentDuplicate
                  size={18}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Duplicar Produto"
                  className="action"
                  color="#0095e8"
                />
                Duplicar Produto
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setUuidProduct({ uuid: row.uuid, isEdite: true })}
            >
              <div
                style={{
                  display: 'flex',
                  gap: '1rem',
                  alignItems: 'center',
                  fontSize: '12px',
                }}
              >
                <FaEdit
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Editar"
                  className="action"
                  onClick={() =>
                    setUuidProduct({ uuid: row.uuid, isEdite: true })
                  }
                  size={16}
                  color="#50cd89"
                />
                Editar
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
      button: true,
    },
  ];

  useEffect(() => {
    if (isLoadingProductById) return;
    const setUuidProduct = (row: any) => {
      if (typeof props.onEditItem === 'function' && row !== undefined) {
        props.onDuplicar(false);
        props.onEditando(true);
        props.onEditItem(productByUuid?.data);
        props.onNewProduct();
      }
    };

    const handleDuplicate = (row: any) => {
      if (typeof props.onEditItem === 'function' && row !== undefined) {
        props.onDuplicar(true);
        props.onEditando(false);
        props.onEditItem(productByUuid?.data);
        props.onNewProduct();
        props.setIfDuplicate(true);
      }
    };

    uuidProduct?.isEdite
      ? setUuidProduct(uuidProduct?.uuid)
      : handleDuplicate(uuidProduct?.uuid);
  }, [isLoadingProductById, productByUuid?.data, props, uuidProduct]);

  if (isLoadingProductById) return <Loading />;

  console.log('productByUuid?.data', productByUuid?.data);

  return (
    <>
      {isImporting && (
        <S.ImportOverlay>
          <Spinner />
          Importando produtos, aguarde...
        </S.ImportOverlay>
      )}
      <ImportResultModal
        result={importResult}
        onClose={() => setImportResult(null)}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx"
        style={{ display: 'none' }}
        onChange={handleImportXls}
      />
      <LayoutFilter
        title="Produtos"
        onClickAdd={handleNew}
        onClickOpenFilter={onClickOpenFilter}
        openFilter={openFilter}
        isLoading={isLoading}
        hasSearchButton={false}
        extraActions={
          <>
            <Button
              variant="success"
              size="sm"
              style={{ padding: '5px 12px' }}
              disabled={isExporting}
              onClick={handleExportXls}
            >
              {isExporting ? 'Exportando...' : 'Exportar XLS'}
            </Button>
            <Button
              variant="info"
              size="sm"
              style={{ padding: '5px 12px' }}
              disabled={isImporting}
              onClick={() => fileInputRef.current?.click()}
            >
              {isImporting ? 'Importando...' : 'Importar XLS'}
            </Button>
          </>
        }
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <InputDefault
                label="Produto"
                placeholder="Produto"
                type="text"
                state={name}
                setState={setName}
              />

              <InputDefault
                label="Código"
                placeholder="Código"
                type="text"
                autoComplete="off"
                state={idPdv}
                maxLength={50}
                onChenge={(e: any) => setIdPdv(e.target.value)}
              />

              <ReactSelect
                label="Categoria"
                placeholder="Categoria"
                isClearable
                state={category}
                options={categories?.data?.map((item: any) => ({
                  ...item,
                  value: item?.id_pdv_category,
                  label: item.name,
                  store_id: item.store_id,
                }))}
                setState={setCategory}
                isLoading={isLoadingCategories}
              />

              <ReactSelect
                label="Tipo"
                placeholder="tipo"
                isClearable
                state={type}
                options={productTypes?.data?.map((item: any) => ({
                  value: item.code,
                  label: item.product_type_description,
                  store_id: item.store_id,
                }))}
                setState={setType}
                isLoading={isLoadingProductTypes}
              />

              <ReactSelect
                label="Status"
                placeholder="Status"
                state={status}
                options={listStatus}
                setState={setStatus}
              />

              <ReactSelect
                label="Período"
                placeholder="Periodo"
                state={typedate}
                options={listdate}
                isInvalid={false}
                setState={setTypeDate}
              />

              <InputDefault
                label="De"
                type="date"
                disabled={typedate === 0}
                state={startDate}
                onChenge={(e: any) => handleDateStart(e.target.value)}
              />

              <InputDefault
                label="Até"
                type="date"
                disabled={typedate === 0}
                state={endDate}
                onChenge={(e: any) => handleDateEnd(e.target.value)}
              />
            </div>
          )}

          <div className="max-screen">
            <InputDefault
              label="Produto"
              placeholder="Produto"
              type="text"
              state={name}
              setState={setName}
            />

            <InputDefault
              label="Código"
              type="text"
              autoComplete="off"
              state={idPdv}
              maxLength={50}
              onChenge={(e: any) => setIdPdv(e.target.value)}
            />

            <ReactSelect
              label="Categoria"
              isClearable
              state={category}
              options={categories?.data?.map((item: any) => ({
                ...item,
                value: item?.id_pdv_category,
                label: item.name,
                store_id: item.store_id,
              }))}
              setState={setCategory}
              isLoading={isLoadingCategories}
            />

            <ReactSelect
              label="Tipo"
              placeholder="tipo"
              isClearable
              state={type}
              options={productTypes?.data?.map((item: any) => ({
                value: item.code,
                label: item.product_type_description,
                store_id: item.store_id,
              }))}
              setState={setType}
              isLoading={isLoadingProductTypes}
            />

            <ReactSelect
              label="Status"
              placeholder="Status"
              state={status}
              options={listStatus}
              setState={setStatus}
            />

            <ReactSelect
              label="Período"
              state={typedate}
              options={listdate}
              isInvalid={false}
              setState={setTypeDate}
            />

            <InputDefault
              label="De"
              type="date"
              disabled={typedate === 0}
              state={startDate}
              onChenge={(e: any) => handleDateStart(e.target.value)}
            />

            <InputDefault
              label="Até"
              type="date"
              disabled={typedate === 0}
              state={endDate}
              onChenge={(e: any) => handleDateEnd(e.target.value)}
            />
          </div>
        </S.Wrapper>
      </LayoutFilter>
      <LayoutTable>
        <DataTable
          columns={columns}
          data={data?.data ?? []}
          striped
          pagination
          paginationServer
          paginationTotalRows={data?.meta?.total}
          paginationDefaultPage={1}
          paginationPerPage={15}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={tableStyleDefault}
          paginationComponentOptions={paginationOptions}
          progressPending={isLoading}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>
    </>
  );
}